import {cn} from "../../utils/helper";
import RightArrowIcon from "../../assets/images/icon/right_arrow_icon.svg";

interface PrincipleCardProps {
    index: string
    title: string
    href?: string
    fullSpan?: boolean
    className?: string
}

export default function PrincipleCard({
                                          index,
                                          title,
                                          href = '#',
                                          fullSpan,
                                          className,
                                      }: PrincipleCardProps) {
    return (
        <a
            href={href}
            className={cn(
                'group relative block md:rounded-xl  bg-[#F5F5F5] p-4 sm:p-6 rounded-[6px]',
                'md:hover:border-gray-300 md:hover:shadow-soft transition',
                fullSpan ? 'col-span-1 sm:col-span-2' : '',
                className,
            )}
        >
            <div className="flex items-center gap-4">
                <div className="flex  items-center justify-center rounded-full text-[#0000ED] font-[800] text-[20px]">
                    {index}
                </div>
                <div className="text-black leading-none font-[600] md:font-[400] text-[1rem] md:text-[20px]">{title}</div>
                <div className="ml-auto">
          <span className="inline-flex h-8 w-[14px] md:w-8 items-center justify-center rounded-full md:bg-gray-50 text-gray-500 group-hover:bg-gray-100">
                <img src={RightArrowIcon} alt=""/>
          </span>
                </div>
            </div>
        </a>
    )
}
